<template>
  <svg
    class="finishing-setup-spinner"
    viewBox="0 0 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.22656 6.22656L9.33101 9.33101"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M3 14H7.4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M6.22656 21.7744L9.33101 18.6699"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14 20.5996V24.9996"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.668 18.6699L21.7724 21.7744"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M20.5996 14H24.9996"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M18.668 9.33101L21.7724 6.22656"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14 3V7.4"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
</template>

<style lang="scss" scoped>
.finishing-setup-spinner {
  --spinner-size: 28px;
  width: var(--spinner-size);
  height: var(--spinner-size);

  path {
    stroke: $c-black-3;
    animation: fade 0.8s linear infinite;

    @for $i from 0 through 7 {
      &:nth-child(#{$i + 1}) {
        animation-delay: $i * -0.1s;
      }
    }
  }
}

@keyframes fade {
  0% {
    opacity: 1;
  }
  100% {
    opacity: 0;
  }
}
</style>
